(function () {
    //get the formApp module
    var formApp = angular.module('formApp');

    //set the controller to the code here - the controller uses DataServices.
    formApp.controller(
        'feedbackPracticeImprovementFormController',
        ['$scope', '$http', '$controller', 'DataServices', 'UtilityServices', 'ValidationService', '$location', '$routeParams', '$rootScope', 'Constants',
            function ($scope, $http, $controller, DataServices, UtilityServices, ValidationService, $location, $routeParams, $rootScope, Constants) {

                // Inherit parent controller
                $controller('questionController', { $scope: $scope });
                $controller('followUpController', { $scope: $scope, feedbackType: Constants.FeedbackType.Complaint, incidentId: DataServices.responseInfo.incidentId });

                // only get the config data if we don't have it
                DataServices.getConfigurationUsingCache(Constants.ConfigTemplate.feedbackPracticeImprovement, $scope.versionNumber, null, DataServices.isAuthenticated())
                    .then(function (data) {
                        $scope.setupTriggersAndDynamicValues();
                        $scope.setSummaryErrorFocus();
                        $scope.isPageEditable = DataServices.isFollowUpEditable === true && $scope.page.isEditable === true;

                        document.title = $scope.utility.getPageTitle($scope.navTabNum, $scope.pageUrl);
                    });

                // Incident specific scope items
                $scope.status = DataServices.responseInfo.status;
                $scope.incidentRef = DataServices.responseInfo.incidentRef;
                $scope.statusText = DataServices.responseInfo.statusText;
                $scope.template = Constants.ConfigTemplate.feedbackPracticeImprovement;

                $scope.savePracticeImprovement = function () {

                    // no validation 
                    $scope.currentLoadSubmitMessage = "Saving Feedback Practice Improvement";

                    $scope.callSaveFollowUp($scope.feedbackType).then(function () {
                        // go back to co-ordination page
                        $scope.returnToCoordinationPage();
                    });
                }

                $scope.submitPracticeImprovement = function () {

                    // implement submit logic
                    if ($scope.validatePage($scope.navTabNum, $scope.pageUrl, null, null, null, 'inline')) {

                        $scope.currentLoadSubmitMessage = "Submitting Feedback Practice Improvement";
                        $scope.callSubmitFollowUp($scope.feedbackType).then(function () {
                            $scope.returnToCoordinationPage();
                        });
                    }
                    else {
                        $scope.moveToFirstError();
                    }
                }

                $scope.cancel = function () {

                    $scope.callCancelFollowUp();
                }
            }]);
}());